import React, { memo } from 'react';
import './timepicker.scss';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
var UTCTimePicker = function (_a) {
    var onChange = _a.onChange, timeValue = _a.timeValue;
    var format = 'H:mm';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "rc-time-picker" },
            React.createElement(TimePicker, { defaultValue: moment.utc(), value: timeValue, onChange: onChange, format: format, showSecond: false, minuteStep: 5, clearIcon: false, hideDisabledOptions: true }))));
};
export default memo(UTCTimePicker);
